import { ProductCategoryActionsTypes } from "./productCategories.types";
import { axiosNoTokenInstance } from "../../axios.config";

export const getProductCategories = () => (dispatch) => {
  dispatch({
    type: ProductCategoryActionsTypes.GET.PRODUCT_CATEGORY_PENDING,
  });

  axiosNoTokenInstance
    .get("/product-category")
    .then((res) =>
      dispatch({
        type: ProductCategoryActionsTypes.GET.PRODUCT_CATEGORY_SUCCESS,
        payload: res.data,
      })
    )
    .catch((error) =>
      dispatch({
        type: ProductCategoryActionsTypes.GET.PRODUCT_CATEGORY_ERROR,
        payload: error.response.data,
      })
    );
};

export const getProductCategory = (categoryId) => (dispatch) => {
  dispatch({
    type: ProductCategoryActionsTypes.GET.PRODUCT_CATEGORY_BY_ID_PENDING,
  });

  axiosNoTokenInstance
    .get(`/product-category/${categoryId}`)
    .then((res) =>
      dispatch({
        type: ProductCategoryActionsTypes.GET.PRODUCT_CATEGORY_BY_ID_SUCCESS,
        payload: res.data,
      })
    )
    .catch((error) =>
      dispatch({
        type: ProductCategoryActionsTypes.GET.PRODUCT_CATEGORY_BY_ID_ERROR,
        payload: error.response.data,
      })
    );
};

export const getProductsByCategoryId = (categoryId) => (dispatch) => {
  dispatch({
    type: ProductCategoryActionsTypes.GET.PRODUCTS_BY_CATEGORY_ID_PENDING,
  });

  axiosNoTokenInstance
    .get(`/product-category/${categoryId}/products`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    })
    .then((res) => {
      dispatch({
        type: ProductCategoryActionsTypes.GET.PRODUCTS_BY_CATEGORY_ID_SUCCESS,
        payload: res.data,
        id: categoryId,
      });
    })
    .catch((error) =>
      dispatch({
        type: ProductCategoryActionsTypes.GET.PRODUCTS_BY_CATEGORY_ID_ERROR,
        payload: error.response.data,
      })
    );
};

export const setProductCategoryFilter = (filter) => (dispatch) => {
  dispatch({
    type: ProductCategoryActionsTypes.SET.PRODUCT_CATEGORY_FILTER,
    payload: filter,
  });
};
